// extracted by mini-css-extract-plugin
export var container = "page-module--container--1ba31";
export var heading = "page-module--heading--be5e4";